/**
 * Safe wrappers for the browser Notification API. Android app WebViews (and
 * some browsers) don't define `Notification` at all, so touching it directly
 * throws "ReferenceError: Notification is not defined".
 */
export const notifSupported = () => typeof window !== 'undefined' && 'Notification' in window;

/** 'default' | 'granted' | 'denied' | 'unsupported' */
export const notifPermission = () => (notifSupported() ? window.Notification.permission : 'unsupported');

export function requestNotifPermission() {
  if (!notifSupported()) return Promise.resolve('unsupported');
  try { return Promise.resolve(window.Notification.requestPermission()); }
  catch (_) { return Promise.resolve('denied'); }
}
